/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `v2_pumpstation` - v2_pumpstation
 * * `v2_pipe` - v2_pipe
 * * `v2_orifice` - v2_orifice
 * * `v2_culvert` - v2_culvert
 * * `v2_weir` - v2_weir
 * * `v2_channel` - v2_channel
 * @export
 */
export const StructureTypeEnum = {
  V2_PUMPSTATION: "v2_pumpstation",
  V2_PIPE: "v2_pipe",
  V2_ORIFICE: "v2_orifice",
  V2_CULVERT: "v2_culvert",
  V2_WEIR: "v2_weir",
  V2_CHANNEL: "v2_channel",
} as const;
export type StructureTypeEnum = (typeof StructureTypeEnum)[keyof typeof StructureTypeEnum];

export function instanceOfStructureTypeEnum(value: any): boolean {
  for (const key in StructureTypeEnum) {
    if (Object.prototype.hasOwnProperty.call(StructureTypeEnum, key)) {
      if (StructureTypeEnum[key as keyof typeof StructureTypeEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function StructureTypeEnumFromJSON(json: any): StructureTypeEnum {
  return StructureTypeEnumFromJSONTyped(json, false);
}

export function StructureTypeEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): StructureTypeEnum {
  return json as StructureTypeEnum;
}

export function StructureTypeEnumToJSON(value?: StructureTypeEnum | null): any {
  return value as any;
}

export function StructureTypeEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): StructureTypeEnum {
  return value as StructureTypeEnum;
}
